/**
 * Prevents Angular change detection from
 * running with certain Web Component callbacks
 */
interface ZoneGlobal extends Window {
  __Zone_disable_customElements?: boolean;
}

(window as ZoneGlobal).__Zone_disable_customElements = true;
